import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { CHART_ANCHORED_TOOLTIP_PROPS, ChartArea } from '../../Chart'
import Text from '../../Text'
import {
  BIRDVIEW_CHART_DATE_KEY,
  BIRDVIEW_TREND_GLYPH,
} from '../DashboardBirdview.constants.charts'
import {
  formatBirdviewNumber,
  getBirdviewTrend,
} from '../DashboardBirdview.utils.charts'

import { BirdviewFlowTooltip } from './BirdviewFlowTooltip'
import {
  BIRDVIEW_FLOW_CHART_GRID_PROPS,
  BIRDVIEW_FLOW_TREND_HEADLINE_KEY,
} from './BirdviewLineChart.constants'
import {
  getBirdviewFlowSeries,
  getBirdviewLineChartXAxisProps,
  getBirdviewLineChartYAxisProps,
} from './BirdviewLineChart.utils'

import * as styles from './BirdviewLineChart.module.css'

function BirdviewLineChart({
  Controls = null,
  closed,
  controlsProps,
  opened,
  points,
}) {
  const { t } = useTranslation()

  const delta = opened - closed
  const trend = getBirdviewTrend(delta)

  return (
    <>
      <div className={styles.verdictRow}>
        <div className={styles.verdict}>
          <span className={classNames(styles.icon, styles[trend])}>
            {BIRDVIEW_TREND_GLYPH[trend]}
          </span>
          <span className={styles.text}>
            <Text className={styles.headline}>
              {t(BIRDVIEW_FLOW_TREND_HEADLINE_KEY[trend], {
                count: formatBirdviewNumber(delta),
              })}
            </Text>
            <Text className={styles.totals}>
              {t('DashboardBirdview.ChartFlowTotalsKey', {
                closed: formatBirdviewNumber(closed),
                opened: formatBirdviewNumber(opened),
              })}
            </Text>
          </span>
        </div>
        {Controls ? <Controls {...controlsProps} /> : null}
      </div>
      <div className={styles.chart}>
        <ChartArea
          data={points}
          gridProps={BIRDVIEW_FLOW_CHART_GRID_PROPS}
          nameKey={BIRDVIEW_CHART_DATE_KEY}
          series={getBirdviewFlowSeries(t)}
          tooltipProps={{
            ...CHART_ANCHORED_TOOLTIP_PROPS,
            content: <BirdviewFlowTooltip />,
          }}
          xAxisProps={getBirdviewLineChartXAxisProps()}
          yAxisProps={getBirdviewLineChartYAxisProps()}
        />
      </div>
    </>
  )
}

export default BirdviewLineChart
